import { render, staticRenderFns } from "./InputPostalCode.vue?vue&type=template&id=ff0699e4"
import script from "./InputPostalCode.vue?vue&type=script&lang=ts"
export * from "./InputPostalCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports